export const exportToCSV = (data, headers, filename) => {
  // Handle both array of strings and array of objects with key/label properties
  const headerKeys = headers.map(h => (typeof h === 'string' ? h : h.key))
  const headerLabels = headers.map(h =>
    typeof h === 'string' ? h : h.label || h.key
  )

  // Create CSV content
  const csvHeaders = headerLabels.join(',')
  const csvRows = data.map(row =>
    headerKeys
      .map(key => {
        const value = row[key]
        // Handle values that contain commas or quotes
        if (
          typeof value === 'string' &&
          (value.includes(',') || value.includes('"'))
        ) {
          return `"${value.replace(/"/g, '""')}"`
        }
        return value ?? ''
      })
      .join(',')
  )

  const csvContent = [csvHeaders, ...csvRows].join('\n')

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)

  link.setAttribute('href', url)
  link.setAttribute(
    'download',
    `${filename}_${new Date().toISOString().split('T')[0]}.csv`
  )
  link.style.visibility = 'hidden'

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const prepareDailyData = data => {
  return data.map(day => ({
    Date: day.date,
    Day: day.day_name,
    Bookings: day.bookings,
    'Showed Up': day.showed_up,
    'No-Shows': day.no_shows,
    'Show Rate (%)': day.show_rate,
    Starts: day.starts,
    Revenue: day.revenue,
    'Conversion Rate (%)': day.conversion_rate,
  }))
}

export const prepareWeeklyData = data => {
  return data.map(week => ({
    'Week Starting': week.week_start,
    Bookings: week.bookings,
    'Showed Up': week.showed_up,
    'No-Shows': week.no_shows,
    'Show Rate (%)':
      week.show_rate ??
      (week.bookings > 0
        ? ((week.showed_up / week.bookings) * 100).toFixed(1)
        : 0),
    Starts: week.starts,
    Revenue: week.revenue || 0,
    'Conversion %':
      week.conversion_rate ??
      (week.bookings > 0
        ? ((week.starts / week.bookings) * 100).toFixed(1)
        : 0),
  }))
}

export const prepareMonthlyData = data => {
  return data.map(month => ({
    Month: month.month,
    Bookings: month.bookings,
    'Showed Up': month.showed_up,
    'No-Shows': month.no_shows,
    Starts: month.starts,
    'Conversion %':
      month.bookings > 0
        ? ((month.starts / month.bookings) * 100).toFixed(1)
        : 0,
  }))
}

export const prepareUTMData = data => {
  return Object.entries(data).map(([source, metrics]) => ({
    Source: source,
    Bookings: metrics.bookings,
    'Showed Up': metrics.showed_up,
    'No-Shows': metrics.no_shows,
    Starts: metrics.starts,
    'Conversion %':
      metrics.bookings > 0
        ? ((metrics.starts / metrics.bookings) * 100).toFixed(1)
        : 0,
  }))
}

export const prepareStartsData = data => {
  return data.map(start => ({
    Date: start.date,
    'Patient Name': start.patient_name,
    Email: start.patient_email,
    Amount: `$${(start.amount / 100).toFixed(2)}`,
    Source: start.utm_source || 'Direct',
    Medium: start.utm_medium || '-',
    Campaign: start.utm_campaign || '-',
  }))
}

export const prepareSummaryData = summary => {
  return [
    {
      Metric: 'Total Bookings',
      Value: summary.total_bookings,
    },
    {
      Metric: 'Total Showed Up',
      Value: summary.total_showed_up,
    },
    {
      Metric: 'Total No-Shows',
      Value: summary.total_no_shows,
    },
    {
      Metric: 'Total Starts',
      Value: summary.total_starts,
    },
    {
      Metric: 'Conversion Rate %',
      Value:
        summary.total_bookings > 0
          ? ((summary.total_starts / summary.total_bookings) * 100).toFixed(1)
          : 0,
    },
  ]
}
